import { useQuery } from '@tanstack/react-query'

import { fetchWithHeaders } from 'utils'

import { GrapeAPIError, type GrapeAPIErrorType } from './GrapeAPIError'
import { type PaginatedResponse } from './types'
import { type MemberDeductions } from '../../types/deductions'
import type { PayPeriod } from '../../types/payroll'

export function useGetConsistentDeductions ({
  payPeriod
}: {
  payPeriod: PayPeriod | undefined,
}) {
  return useQuery<PaginatedResponse<MemberDeductions>, GrapeAPIErrorType>({
    queryKey: [
      'pay_period',
      payPeriod?.id || ''
    ],
    queryFn: async () => {
      const response = await fetchWithHeaders(`/api/web/payroll/consistent_deductions?pay_period_id=${payPeriod?.id}`)
      if (!response.ok) {
        const errorJson = await response.json()
        throw GrapeAPIError({
          status: response.status,
          message: errorJson.message,
          errors: errorJson.errors
        })
      }
      return response.json()
    },
    enabled: !!(payPeriod && !!payPeriod.id && payPeriod.status !== 'pending')
  })
}
